import Swiper, { Navigation, Pagination, Autoplay,EffectFade } from 'swiper';
const gridSlider = {

    init() {
        if ($('.jsGrid').length > 0) {
            this.initSlider();
        }
    },
    initSlider() {
        new Swiper($('.jsGrid')[0], {
            slidesPerView: 1,
            // autoplay:true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            centeredSlides: true,
            loop: true,
            modules: [Navigation, Pagination,Autoplay,EffectFade],
        });
    },
  
}
export default gridSlider;



// WEBPACK FOOTER //
// ./scripts/modules/components/_grid-swiper.js